import React, { useRef } from 'react';
import type videojs from 'video.js';
import { detectVideoMimeType } from '@common/media';
import { cn } from '../../../lib/utils';
import ProtectedMediaWrapper from '../../media/ProtectedMediaWrapper';
import VideoPlayer from './VideoJsPlayer';

interface TMessageAttachment {
  url: string;
  label?: string;
}

const VIDEO_URL = import.meta.env.VITE_VIDEO_URL;

function VideoMessage({ url, label }: TMessageAttachment) {
  const playerRef = useRef<ReturnType<typeof videojs> | null>(null);

  const videoJsOptions: IVideoOptionsProps = {
    autoplay: false,
    controls: true,
    responsive: true,
    playsinline: true,
    fluid: true,
    disablePictureInPicture: true,
    controlsList: 'nodownload',
    sources: [
      {
        src: `${url}${url?.includes(VIDEO_URL) ? '#t=0.001' : ''}`,
        type: detectVideoMimeType(url),
      },
    ],
  };

  const handlePlayerReady = (player: ReturnType<typeof videojs>) => {
    playerRef.current = player;

    player.on('waiting', () => {
      // videojs.log('player is waiting');
    });

    player.on('dispose', () => {
      // videojs.log('player will dispose');
    });
  };

  return (
    <ProtectedMediaWrapper noOverlay className={cn('flex items-center max-w-full w-[50rem]')}>
      <VideoPlayer options={videoJsOptions} onReady={handlePlayerReady} />
    </ProtectedMediaWrapper>
  );
}

export default React.memo(VideoMessage);
